export const chatBotMessagePurpose = [
  {
    title: "Welcome Message",
  },
  {
    title: "Welcome Message (SMS)",
  },
  {
    title: "Extension Welcome",
  },
  {
    title: "Extension Link Expire",
  },
  {
    title: "Validation Link Expire",
  },
  {
    title: "Welcome Message (VIP Parking)",
  },
  {
    title: "Welcome Message (Validation)",
  },
  {
    title: "Welcome Message (Unit Parking)",
  },
  {
    title: "Space Selection Form (Unit Parking)",
  },
  {
    title: "Rate Selection Form (Unit Parking)",
  },
  {
    title: "Additional License Plate Form (Unit Parking)",
  },
  {
    title: "Detail Confirmation Message (Unit Parking)",
  },

  {
    title: "License Plate Update",
  },
  {
    title: "License Plate Update Success",
  },
  {
    title: "Welcome Message (Pay Now Validation Later Flow)",
  },
  {
    title: "Welcome Message (Parent Rate)",
  },
  {
    title: "After LicensePlate Submission SMS (Two Step Validation)",
  },
  {
    title: "After LicensePlate Submission (Two Step Validation)",
  },
  {
    title: "Payment Confirmation (Two Step Validation)",
  },
  {
    title: "Validation Reminder SMS",
  },
  {
    title: "On Rate Selection",
  },
  {
    title: "License Plate Form",
  },
  {
    title: "Pass Form",
  },
  {
    title: "License Plate Confirmation",
  },
  {
    title: "Monthly Rate Form",
  },
  {
    title: "Payment Card",
  },
  {
    title: "Payment Card (Monthly)",
  },

  {
    title: "Payment Confirmation (Pay Now Validation Later Flow)",
  },
  {
    title: "Payment Confirmation",
  },
  {
    title: "Payment Confirmation (Monthly)",
  },
  {
    title: "Payment Confirmation SMS",
  },
  {
    title: "Extension Reminder",
  },
  {
    title: "Unavailability",
  },
  {
    title: "Unavailability (Extension)",
  },
  { title: "Space Unavailability" },
  {
    title: "Help",
  },
  {
    title: "Help SMS",
  },
  {
    title: "Learn More",
  },
  {
    title: "Contact",
  },
  {
    title: "Permit Creation Form",
  },
  {
    title: "Permit Form Submit",
  },
  {
    title: "Welcome Message (Permit)",
  },
  {
    title: "Free Parking Limit Reached",
  },
];
export const SMSMessagePurpose = [
  {
    title: "Welcome Message",
  },
  {
    title: "On Hour Selection",
  },
  {
    title: "Help",
  },
  {
    title: "Learn More",
  },
  {
    title: "Contact",
  },
];

export const purposeTags = {
  "After LicensePlate Submission (Two Step Validation)": [
    "displayName",
    "placeAddress",
    "brandName",
    "lotName",
    "licensePlate",
    "rateTitle",
    "amount",
    "totalAmount",
    "serviceFee",
    "totalTax",
    "cityTax",
    "countyTax",
    "parentDisplayName",
    "validationLink"
  ],

  "After LicensePlate Submission SMS (Two Step Validation)": [
    "displayName",
    "placeAddress",
    "brandName",
    "lotName",
    "licensePlate",
    "rateTitle",
    "totalAmount",
    "serviceFee",
    "totalTax",
    "cityTax",
    "countyTax",
    "validationLink",
  ],

  // Contact: ["placeAddress", "brandName", "lotName"],

  "Expiration Reminder": [
    "placeAddress",
    "brandName",
    "lotName",
    "extensionLink",
  ],

  "Extension Reminder": [
    "placeAddress",
    "brandName",
    "lotName",
    "extensionLink",
    "licensePlate",
    "updateLicensePlateLink",
  ],

  "Extension Welcome": ["brandName", "placeAddress", "lotName"],

  "License Plate Update": [
    "brandName",
    "placeAddress",
    "lotName",
    "parkingCode",
    "currentLicensePlate",
  ],
  "License Plate Update Success": [
    "brandName",
    "placeAddress",
    "lotName",
    "parkingCode",
    "currentLicensePlate",
    "oldLicensePlate",
  ],

  "VIP Parking Extension Welcome": ["brandName", "placeAddress", "lotName"],

  // Help: ["brandName", "placeAddress", "lotName"],

  // "Learn More": ["placeAddress", "brandName", "lotName"],

  "License Plate Form": [
    "amount",
    "brandName",
    "placeAddress",
    "lotName",
    "baseRate",
    "totalAmount",
    "serviceFee",
    "tax",
    "totalTax",
    "cityTax",
    "countyTax",
    "rateTitle",
    "displayName",
    "termAndConditionLink",
    "plivoNumber",
  ],

  "Pass Form": [
    "amount",
    "brandName",
    "placeAddress",
    "lotName",
    "baseRate",
    "totalAmount",
    "serviceFee",
    "TotalTax",
    "cityTax",
    "countyTax",
    "rateTitle",
    "displayName",
  ],

  "On Rate Selection": [
    "amount",
    "brandName",
    "placeAddress",
    "lotName",
    "baseRate",
    "totalAmount",
    "serviceFee",
    "totalTax",
    "cityTax",
    "countyTax",
    "displayName",
    "rateTitle",
    // "parentDisplayName",
  ],

  "Payment Card": [
    "amount",
    "brandName",
    "placeAddress",
    "lotName",
    "baseRate",
    "totalAmount",
    "serviceFee",
    "totalTax",
    "cityTax",
    "countyTax",
    "parentDisplayName",
  ],

  "Payment Card (Monthly)": [
    "amount",
    "brandName",
    "placeAddress",
    "lotName",
    "baseRate",
    "totalAmount",
    "serviceFee",
    "TotalTax",
    "cityTax",
    "countyTax",
    "parentDisplayName",
    "displayName",
    "rateTitle",
  ],

  "Payment Confirmation": [
    "brandName",
    "placeAddress",
    "lotName",
    "totalAmount",
    "licensePlate",
    // "extensionLink",
    // "updateLicensePlateLink",
  ],

  "Payment Confirmation (Monthly)": [
    "brandName",
    "placeAddress",
    "lotName",
    "totalAmount",
    "licensePlate",
  ],

  "Payment Confirmation SMS": [
    "placeAddress",
    "brandName",
    "lotName",
    "licensePlate",
    "totalAmount",
    "receiptURL",
    "extensionLink",
    "updateLicensePlateLink",
  ],

  Unavailability: ["placeAddress", "brandName", "lotName"],

  "Validation Reminder SMS": [
    "placeAddress",
    "brandName",
    "lotName",
    "validationLink",
    "licensePlate",
  ],

  "Welcome Message (Validation)": [
    "displayName",
    "rateTitle",
    "brandName",
    "placeAddress",
    "lotName",
  ],

  "Welcome Message": ["brandName", "placeAddress", "lotName"],
  "Welcome Message (SMS)": [
    "brandName",
    "placeAddress",
    "lotName",
    "chatbotURL",
  ],

  "Welcome Message (Parent Rate)": [
    "brandName",
    "placeAddress",
    "lotName",
    "rateTitle",
    "parentDisplayName",
  ],

  "Welcome Message (Permit)": ["placeAddress", "brandName", "lotName"],

  "Welcome Message (VIP Parking)": ["brandName", "placeAddress", "lotName"],

  "License Plate Confirmation": ["licensePlate"],

  "Free Parking Limit Reached": [
    "brandName",
    "placeAddress",
    "lotName",
    "licensePlate",
  ],

  "": [],

  "Welcome Message (Unit Parking)": ["brandName", "placeAddress", "lotName"],

  "Welcome Message (Pay Now Validation Later Flow)": [
    "brandName",
    "placeAddress",
    "lotName",
  ],

  "Extension Link Expire": ["brandName", "placeAddress", "lotName"],
  "Validation Link Expire": ["brandName", "placeAddress", "lotName"],

  "Payment Confirmation (Two Step Validation)": [
    "brandName",
    "placeAddress",
    "lotName",
    "totalAmount",
    "parentDisplayName",
    "licensePlate",
  ],
  "Payment Confirmation (Pay Now Validation Later Flow)": [
    "brandName",
    "placeAddress",
    "lotName",
    "totalAmount",
    "licensePlate",
  ],

  "Unavailability (Extension)": ["placeAddress", "brandName", "lotName"],

  "Space Unavailability": ["placeAddress", "brandName", "lotName", "rate"],

  "Help SMS": ["placeAddress", "brandName", "lotName", "chatbotURL"],

  "Permit Form Submit": [
    "placeAddress",
    "brandName",
    "lotName",
    "licensePlate",
  ],
};

export const chatBotMessagePurposeColorCodes = {
  "Welcome Message": "#FF5733",
  "Extension Welcome": "#00FF00",
  "Welcome Message (Validation)": "#0000FF",
  "Welcome Message (Parent Rate)": "#FF00FF",
  "After LicensePlate Submission SMS (Two Step Validation)": "#FF0066",
  "After LicensePlate Submission (Two Step Validation)": "#8000FF",
  "Validation Reminder SMS": "#00FF99",
  "On Rate Selection": "#FF8000",
  "License Plate Form": "#80FF00",
  "Monthly Rate Form": "#3300FF",
  "Payment Card": "#00FF33",
  "Payment Card (Monthly)": "#FF00CC",
  "Payment Confirmation": "#3399FF",
  "Payment Confirmation (Monthly)": "#FF3399",
  "Payment Confirmation SMS": "#00FF80",
  "Extension Reminder": "#CCFF00",
  Unavailability: "#FF0000",
  Help: "#00FF66",
  "Learn More": "#0000CC",
  Contact: "#FF00FF",
  "Permit Creation Form": "#FF0066",
  "Permit Form Submit": "#8000FF",
  "Welcome Message (Permit)": "#06402B",
};
